import React from "react";
import Library from "../Library";

const Icon = (props) => <Library name="address-card-o" {...props} />;

Icon.displayName = "Icon.AddressCard";
export default Icon;
